<template>
  <div class="container product-wrapper">
    <h2>The Cybersecurity Threat of DDoS</h2>
    <div class="row">
      <div class="col-lg-6 product-text key-point-text">
        <h1>What is DDoS?</h1>
        <p>
          A distributed denial-of-service attack (DDoS attack) is when an
          attacker floods a victim's internet network with malicious traffic,
          aimed at overwhelming it and causing catastrophic downtime ranging
          from seconds to weeks.
        </p>
        <p>
          This downtime can cause permanent damage to your brand, loss of
          customer confidence, and major financial loss.
        </p>
        <p>
          Any internet-facing property your organization and users rely on is
          potentially vulnerable to DDoS attacks.
        </p>
      </div>
      <div class="col-lg-6 product-text key-point-text">
        <h1>DDoS Protection</h1>
        <p>
          DDoS Mitigation solutions are designed to combat these attacks by
          separating the good traffic from the bad traffic.
        </p>
        <p>
          However, not all DDoS solutions are built the same.<br />Some have
          issues that can do more harm than help:
        </p>
        <ul>
          <li>Slow mitigation times causing downtime for minutes</li>
          <li>High-latency unsuitable for high-speed applications</li>
          <li>False positives blocking real customers</li>
          <li>Failure to protect against sophisticated attacks</li>
        </ul>
      </div>
    </div>
    <div class="row img-container">
      <div class="col-md-12">
        <img
          v-if="cat === 'gaming'"
          src="@/assets/img/compare_traffic_games.png"
        />
        <img v-else src="@/assets/img/compare_traffic_servers.png" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Explanation",
  props: {
    home: {
      type: Boolean,
      default: false,
    },
    cat: {
      type: String,
      default: null,
    },
  },
  computed: {
    header: function() {
      return {};
    },
  },
};
</script>

<style scoped>
.img-container {
  overflow: hidden;
}
@media only screen and (max-width: 768px) {
  .img-container {
    display: none;
  }
}
.key-point-text {
  padding-right: 3.5em;
}
.product-wrapper {
  padding-right: 2.5em;
  padding-left: 2.5em;
}
</style>
